import { memo, useEffect, useMemo, useState } from 'react';
import { Tag } from '@chakra-ui/react';

import { useApi } from '@app/hooks';
import { useVisitGuides } from '@app/hooks/react-native/use-visit-guides';
import { getRoleName } from '@app/utils/jwt';

const MenuItemCounterComponent = ({ counterId }: {
  counterId: string
}) => {
  const [value, setValue] = useState(0);
  const { variables } = useVisitGuides();
  const api = useApi();

  const apiMethods = useMemo(() => ({
    'new-outlets': api.acb.getNewCount,
    'updates-outlets': api.acb.getUpdateCount,
    'repairs': api.equipments.getEquipmentsRepairCount
  }), []);

  const access: Record<string, string[]> = useMemo(() => {
    if (!variables?.['MENU_COUNTERS_ACCESS']?.value) {return {};}
    try {
     return JSON.parse(variables?.['MENU_COUNTERS_ACCESS']?.value);
    } catch (e) {
      console.log(e);
      return {};
    }
  }, [variables]);

  const canView: boolean = useMemo(() => {
    const roles = access?.[counterId];
    const roleName = getRoleName();
    return !!roleName && !!roles?.includes(roleName);
  }, [access, counterId]);

  useEffect(() => {
    console.log('changed apiMethods', apiMethods);
  }, [apiMethods]);

  useEffect(() => {
    if (!canView) { return; }

    (async () => {
      const value = await apiMethods[counterId]?.();
      setValue(value.data);
    })();

    const timerId = setInterval(async () => {
      const value = await apiMethods[counterId]?.();
      setValue(value.data);
    }, 60_000);

    return () => clearInterval(timerId); 
  }, [apiMethods, canView, counterId]);
  
  if (!canView || !value) {return null;}

  {return <Tag >{value}</Tag>;}
};

export const MenuItemCounter = memo(MenuItemCounterComponent);